var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-nav c-nav--vertical" },
    [
      _c("li", [
        _c(
          "label",
          {
            staticClass: "c-btn c-btn--invisible c-btn--vert-center",
            class: {
              "is-active": _vm.bedroomState.length === 0
            },
            attrs: { for: "bedrooms-all" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bedroomState,
                  expression: "bedroomState"
                }
              ],
              staticClass: "screen-reader-text",
              attrs: { id: "bedrooms-all", type: "radio", name: "bedrooms" },
              domProps: { value: [], checked: _vm._q(_vm.bedroomState, []) },
              on: {
                change: function($event) {
                  _vm.bedroomState = []
                }
              }
            }),
            _vm._v(" "),
            _c("Toggle", {
              staticClass: "c-btn__icon c-btn__icon--alignment",
              attrs: { isSelected: _vm.bedroomState.length === 0 }
            }),
            _vm._v("\n      Alle\n    ")
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.bedrooms, function(bedroom) {
        return _c("li", { key: bedroom.id }, [
          _c(
            "label",
            {
              staticClass: "c-btn c-btn--invisible c-btn--vert-center",
              class: {
                "is-active": _vm.bedroomState.includes(bedroom.name)
              },
              attrs: { for: "bedrooms-" + bedroom.id }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.bedroomState,
                    expression: "bedroomState"
                  }
                ],
                staticClass: "screen-reader-text",
                attrs: {
                  id: "bedrooms-" + bedroom.id,
                  type: "checkbox",
                  name: "bedrooms"
                },
                domProps: {
                  value: bedroom.name,
                  checked: Array.isArray(_vm.bedroomState)
                    ? _vm._i(_vm.bedroomState, bedroom.name) > -1
                    : _vm.bedroomState
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.bedroomState,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = bedroom.name,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.bedroomState = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.bedroomState = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.bedroomState = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("Toggle", {
                staticClass: "c-btn__icon c-btn__icon--alignment",
                attrs: {
                  isSelected: _vm.bedroomState.includes(bedroom.name) === true
                }
              }),
              _vm._v("\n      " + _vm._s(bedroom.name) + " soverom\n    ")
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }